// @preval

const fs = require('fs');
const path = require('path');
const languageFolders = fs.readdirSync(__dirname);

const overwrite = languageFolders.reduce((result, languageFolderName) => {
  const languageFolderPath = path.resolve(__dirname, languageFolderName);

  if(isDirectory(languageFolderPath)) {
    const languageDir = fs.readdirSync(languageFolderPath);
    result[languageFolderName] = getFolderAsJson(languageFolderName, languageDir);
  }

  return result;
}, {});

function getFolderAsJson(path, languageDir) {
  return languageDir.reduce((languages, translateFile) => {
    const encurtedTranslateFilePath = `/${path}/${translateFile}`;
    const fullFilePath = __dirname + encurtedTranslateFilePath;
    const languageFolders = isDirectory(fullFilePath) && fs.readdirSync(fullFilePath);
    const file = isDirectory(fullFilePath)
      ? getFolderAsJson(encurtedTranslateFilePath, languageFolders)
      : require('.' + encurtedTranslateFilePath);

    const fileNameWithoutSulfix = translateFile.replace('.js', '');
    if(fileNameWithoutSulfix === 'index') {
      languages = {...languages, ...file};

      return languages;
    }
    languages[fileNameWithoutSulfix] = file;

    return languages;
  }, {});
}

function isDirectory(path) {
  try {
    const file = fs.lstatSync(path);

    return file.isDirectory();
  } catch (e) {
    return false;
  }
}

module.exports = { overwrite };
